<script>
    import SiteHeaderMc from './components/molecules/SiteHeaderMc';
    import SiteFooter from './components/molecules/SiteFooter';
    import CookieBanner from './components/molecules/CookieBanner';
    import getBrandDetails from './constants/brand.config';
    import HomePage from "./views/HomePage.vue";
    import AboutPage from "./views/AboutPage";
    import NewBoatPage from "./views/NewBoatPage";
    import UsedBoats from "./views/organisms/UsedBoat";
    import CompareBoat from "./views/organisms/CompareBoat";
    import BoatDetailsPage from "./views/organisms/BoatDetailsPage.vue";
    import ContactUS from "./components/ContactUS.vue";
    import ContactSellerForm from "./components/ContactSellerForm.vue";
    import PartsServicesForm from "./components/PartsServicesForm.vue";
    import RequestBrochureForm from "./components/RequestBrochureForm.vue";
    import TradeInForm from "./components/TradeInForm.vue";
    import IframePage from "./components/molecules/IframePage.vue";
    import NewsEvents from "./views/organisms/NewsEvents.vue";
    import NewsArticle from "./views/organisms/NewsArticle.vue";
    import ProfilePage from "./views/organisms/ProfilePage.vue";
    import AdminCmsPage from "./views/AdminCmsPage.vue";
    import TraderCmsPage from "./views/organisms/TraderCmsPage.vue";
    import BrandsCmsPage from "./views/organisms/BrandsCmsPage.vue";
    import SiteOptionsCmsPage from "./views/organisms/SiteOptionsCmsPage.vue";
    import AccessDeniedPage from "./views/organisms/AccessDeniedPage.vue";

    export default {
        name: "App",
        props: ["location"],
        components: {
            "SiteHeaderMc": SiteHeaderMc,
            "SiteFooter": SiteFooter,
            "CookieBanner": CookieBanner,
            "HomePage": HomePage,
            "AboutPage": AboutPage,
            "NewBoatPage": NewBoatPage,
            "UsedBoats": UsedBoats,
            "CompareBoat": CompareBoat,
            "BoatDetailsPage": BoatDetailsPage,
            "ContactUs": ContactUS,
            "ContactSellerForm": ContactSellerForm,
            "PartsServicesForm": PartsServicesForm,
            "RequestBrochureForm": RequestBrochureForm,
            "TradeInForm": TradeInForm,
            "IframePage": IframePage,
            "NewsEvents": NewsEvents,
            "NewsArticle": NewsArticle,
            "ProfilePage": ProfilePage,
            "AdminCmsPage": AdminCmsPage,
            "TraderCmsPage": TraderCmsPage,
            "BrandsCmsPage": BrandsCmsPage,
            "SiteOptionsCmsPage": SiteOptionsCmsPage,
            "AccessDeniedPage": AccessDeniedPage,
        },
        methods: {
            getBrandDetails,            
        },
        computed: {
            brand() {
                let domain = window.location.host.toLowerCase();
                let brands = ["mastercraft", "crest", "balise"];

                for (let i in brands) {
                    if (domain.includes(brands[i])) {
                        sessionStorage.setItem('brand', brands[i])
                        return brands[i];
                    }
                }
                sessionStorage.setItem('brand', brands[0]);
                return brands[0];
            },
        },
        mounted() {
            // check for active theme
            let htmlElement = document.documentElement;
            htmlElement.setAttribute("theme", this.brand);
        }
    };
</script>
